import { useRouter } from 'next/router';

export const useRedirectToTravelTime = () => {
    const router = useRouter();

    const redirectToTravelTime = () => {
        // Get the current URL and parse its parameters
        const currentUrl = new URL(router.asPath, window.location.origin);
        const currentParams = currentUrl.searchParams;

        // Add the time travel params
        //defaults to driving but users can change this upon landing on the LSRP
        currentParams.set('search_source', 'travel-time');
        currentParams.set('transport_type', 'driving');
        currentParams.set('duration', '900');

        // Builds the new URL
        const newUrl = currentUrl.pathname + '?' + currentParams.toString();

        // Redirect the user to the new URL and keeps their current search
        //instead of just redirecting users to /travel-time
        router.push(newUrl);
    };

    return redirectToTravelTime;
};
